<template>
  <section>
    <el-dialog :visible.sync="dialogVisible_approve">
      <Approve v-if="dialogVisible_approve" @approve_submit="approve_submit" :SP_IF="SP_IF" :ApproveList="request_list"></Approve>
    </el-dialog>
    <el-form class="form_cls" :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent>
      <el-form-item label="">
        <el-input v-model="filters.key" :style="isMobile ? 'width: 230px !important;' : ''" placeholder="医院名称/任职机构"></el-input>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button
          :type="
            item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'
          "
          v-if="!item.IsHide && (isMobile && item.name == '导出' ? false : true)"
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
      <!-- <el-form-item> -->
      <el-collapse class="collapsessss" accordion v-model="collapses_val">
        <el-collapse-item :name="0">
          <template slot="title">
            <div style="display: flex; justify-content: space-between; width: 100%">
              <span>达成率汇总</span>
              <div v-if="sionsummary_list.approvalStatus">
                审批状态：
                <span style="color: #6170d7; font-size: 12px">
                  {{
                    sionsummary_list.approvalStatus == 1
                      ? '待审批'
                      : sionsummary_list.approvalStatus == 2
                      ? '审核通过'
                      : sionsummary_list.approvalStatus == 3
                      ? '审核未通过'
                      : ''
                  }}
                </span>
              </div>
            </div>
          </template>
          <div style="margin-left: 5px; margin-bottom: 10px">
            <div style="font-size: 12px; margin-bottom: 0px">
              <span>YTD{{ now_Month }}月-片数/达成：</span>
              <!-- <span style="color: #00b4ff"> -->
              {{ currency(sionsummary_list.ytdNumberSum) }} / {{ (Number(sionsummary_list.ytdNumberAchieved) * 100).toFixed(0) }}%
              <!-- </span> -->
            </div>
            <div style="font-size: 12px; margin-bottom: 10px">
              <span>YTD{{ now_Month }}月-金额/达成：</span>
              <!-- <span style="color: #00b4ff"> -->
              {{ currency(sionsummary_list.ytdAmountSum) }} / {{ (Number(sionsummary_list.ytdAmountAchieved) * 100).toFixed(0) }}%
              <!-- </span> -->
            </div>
          </div>
          <el-table
            border
            class="expends_cls2"
            :data="sionsummary_list.achievements"
            :header-cell-style="{
              'text-align': 'center',
              color: '#6170d7',
              backgroundColor: '#F5F7FA',
              padding: ' 0px 0 !important',
              fontSize: '10px',
            }"
            :cell-style="{ 'text-align': 'center' }"
            highlight-current-row
            header-cell-class-name="header_cell_name"
            @current-change="selectCurrentRow"
            v-loading="listLoading"
            @selection-change="selsChange"
            :style="isMobile ? 'width:100%' : 'width:500px'"
          >
            <el-table-column prop="categoryName" label="品类" width="65">
              <template slot-scope="scope">
                <span style="font-size: 10px">{{ scope.row.categoryName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="categoryName" :label="now_Month + '月'">
              <el-table-column prop="ytdPieceAchieved" label="片数/达成" width="58">
                <template slot-scope="scope">
                  <span style="font-size: 11px">{{ currency(scope.row.number1) + '/' + toFixeds2(scope.row.achieve1) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="ytdPieceAchieved" label="金额/达成" width="">
                <template slot-scope="scope">
                  <span style="font-size: 11px">{{ currency(scope.row.numberPrice1) + '/' + toFixeds2(scope.row.achievePrice1) }}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="categoryName" :label="next_Month + '月'">
              <el-table-column prop="ytdPieceAchieved" label="片数/达成" width="58">
                <template slot-scope="scope">
                  <span style="font-size: 11px">{{ currency(scope.row.number2) + '/' + toFixeds2(scope.row.achieve2) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="ytdPieceAchieved" label="金额/达成" width="">
                <template slot-scope="scope">
                  <span style="font-size: 11px">{{ currency(scope.row.numberPrice2) + '/' + toFixeds2(scope.row.achievePrice2) }}</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <div v-if="sionsummary_list.message">驳回原因：{{ sionsummary_list.message }}</div>
          <div style="text-align: right">
            <el-button v-if="sionsummary_list.approvalStatus != 2" style="margin-top: 20px" :type="'primary'" @click.stop="submit_apply()">
              提交审核
            </el-button>
          </div>
        </el-collapse-item>
      </el-collapse>
      <!-- </el-form-item> -->
    </el-form>

    <!--列表-->
    <div v-if="isMobile" class="table_top_div">
      <EstimateListMobile :approvalStatus="sionsummary_list.approvalStatus" :tabel_list="tabel_list"></EstimateListMobile>
    </div>
    <div v-else>
      <div v-if="SP_IF" style="margin-bottom: 5px">
        <div style="background-color: white; padding: 30px; border-radius: 10px">
          <Approve v-if="SP_IF" :SP_IF="SP_IF" @approve_submit="approve_submit" :ApproveList="tabel_list[0].approvaResultDto"></Approve>
        </div>
      </div>
      <div class="table_top_div" v-for="(item, indexitem) in tabel_list" style="margin-bottom: 5px">
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 5px 0 0 15px; margin-bottom: 10px">
          <div>
            <span style="margin-bottom: 5px; font-size: 18px; font-weight: bold; display: inline-block; color: #6170d7; vertical-align: sub">
              {{ item.details[0].hospitalName }}
            </span>
            <el-button
              :disabled="sionsummary_list.approvalStatus == 2"
              :type="sionsummary_list.approvalStatus == 2 ? 'info' : 'primary'"
              style="margin-left: 20px"
              v-preventReClick="3000"
              @click="save(item)"
            >
              确认上报
            </el-button>
          </div>
          <!-- <el-tag style="vertical-align: middle" :type="item.isReportedThisWeek ? 'success' : 'danger'">
            {{ item.isReportedThisWeek ? '本周已填报' : '本周未填报' }}
          </el-tag> -->
        </div>
        <el-table
          border
          max-height="100%"
          :data="item.details"
          :span-method="objectSpanMethod"
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA', padding: ' 5px 0 !important' }"
          :cell-style="{ 'text-align': 'center' }"
          highlight-current-row
          header-cell-class-name="header_cell_name"
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
          style="width: 100%"
        >
          <el-table-column type="index" label="序号" width="80">
            <template slot-scope="scope">
              {{ indexitem + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="groupM" label="Produce Group" width="130"></el-table-column>
          <!-- <el-table-column prop="groupM" label="Produce Group" width></el-table-column> -->
          <el-table-column prop="productSKU" label="产品编码" width></el-table-column>
          <!-- <el-table-column prop="hospitalName" label="医院名称" width></el-table-column> -->
          <el-table-column label="指标片数">
            <el-table-column prop="monthlyTargetQuantity" :label="now_Month + '月'" width=""></el-table-column>
            <el-table-column prop="nextMonthTarget" :label="next_Month + '月'" width=""></el-table-column>
          </el-table-column>
          <!-- <el-table-column prop="monthlyTargetQuantity" label="月指标片数" width></el-table-column> -->
          <el-table-column label="预估片数">
            <el-table-column prop="estimatedQuantity1" :label="now_Month + '月'" width="">
              <template slot-scope="scope">
                <el-input
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  v-model="scope.row.estimatedQuantity1"
                  class="border_none"
                  placeholder="请填写"
                  :disabled="!(today_if == 2) || scope.row.groupM == 'TTL'"
                  @blur="blurInputs1(scope.row, item.details)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="estimatedQuantity2" :label="next_Month + '月'" width="">
              <template slot-scope="scope">
                <el-input
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  v-model="scope.row.estimatedQuantity2"
                  :disabled="!(today_if == 2) || scope.row.groupM == 'TTL'"
                  class="border_none"
                  placeholder="请填写"
                  @blur="blurInputs1(scope.row, item.details)"
                ></el-input>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column prop="monthlyTargetAmount" label="月指标金额" width="">
            <template slot-scope="scope">
              {{ scope.row.groupM == 'TTL' ? currency(scope.row.totalMonthlyTargetAmount) : currency(scope.row.monthlyTargetAmount) }}
            </template>
          </el-table-column>
          <el-table-column label="预估金额">
            <el-table-column prop="estimatedAmount1" :label="now_Month + '月'" width>
              <template slot-scope="scope">
                {{ scope.row.groupM == 'TTL' ? currency(scope.row.totalEstimatedAmount1) : currency(scope.row.estimatedAmount1) }}
              </template>
            </el-table-column>
            <el-table-column prop="estimatedAmount2" :label="next_Month + '月'" width>
              <template slot-scope="scope">
                {{ scope.row.groupM == 'TTL' ? currency(scope.row.totalEstimatedAmount2) : currency(scope.row.estimatedAmount2) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column prop="totalEstimatedCompletion1" :label="'预估达成-' + now_Month + '月'" width="120">
            <template slot-scope="scope">
              {{ toFixeds(scope.row.groupM == 'TTL' ? scope.row.totalEstimatedCompletion1 : scope.row.estimatedCompletion1) }}
            </template>
          </el-table-column>
          <el-table-column prop="totalEstimatedGrowth1" :label="'预估增长-' + now_Month + '月'" width="120">
            <template slot-scope="scope">
              {{ toFixeds(scope.row.groupM == 'TTL' ? scope.row.totalEstimatedGrowth1 : scope.row.estimatedGrowth1) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog title="导出" :visible.sync="dialogVisible_upload" width="40%">
      <el-form :model="upload_from" label-width="80px" inline>
        <el-form-item label="">
          <el-date-picker v-model="upload_from.startTime" type="month" placeholder="开始日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="">
          <el-date-picker v-model="upload_from.endTime" type="month" placeholder="结束日期"></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_upload = false">取 消</el-button>
        <el-button type="primary" @click="uploads()">导 出</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import util from '../../../util/date'
import {
  estimate_getlist,
  estimate_exportdata,
  estimate_submitestimate,
  estimate_getsubmissionsummary,
  estimate_monthlyreportsummary,
  estimate_submissionsummary,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import { uploadfiles } from '@/uploadfiles'
import { quillEditor } from 'vue-quill-editor'
import EstimateListMobile from './mobile/EstimateListMobile'
import Toolbar from '../../components/Toolbar'
import Approve from '../../components/Approve'

export default {
  components: { Toolbar, quillEditor, Approve, EstimateListMobile },
  data() {
    return {
      collapses_val: [0],
      sionsummary_list: [],
      next_Month: '',
      today_if: 0,
      upload_from: {},
      dialogVisible_approve: false,
      dialogVisible_upload: false,
      SP_IF: '',
      isMobile: false,
      request_list: [],
      description_text: '',
      rolename_if: false,
      num_zt: 0,
      tableHeight: 0,
      buttonList: [],
      editorOption: {
        // editorOption里是放图片上传配置参数用的，例如：
        action: '/images/Upload/Pic', // 必填参数 图片上传地址
        methods: 'post', // 必填参数 图片上传方式
        token: this.token, // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
        // name: 'upload_file',  // 必填参数 文件的参数名
        // size: 500,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
        // accept: 'multipart/form-data, image/png, image/gif, image/jpeg, image/bmp, image/x-icon,image/jpg'  // 可选 可上传的图片格式
      },
      token: '',
      addLoading: false,
      editFormRules: {
        html: [{ required: true, message: '请填写', trigger: 'blur' }],
        type: [{ required: true, message: '请填写', trigger: 'blur' }],
      },
      currentRow: null,
      filters: {
        pageSize: 200,
      },
      tabel_list: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      pageNumber: 1,
      listLoading: false,
      sels: [], //列表选中列
    }
  },
  methods: {
    submit_apply(e) {
      this.$confirm('确定提交审核？', '提示', {
        type: 'warning',
      }).then(async () => {
        const { data } = await estimate_submissionsummary()
        if (data.code == 200) {
          this.$message({
            message: data.msg,
            type: 'success',
          })
          this.estimate_getsubmissionsummary_fn()
          this.getModules()
        } else {
          this.$message({
            message: data.msg,
            type: 'error',
          })
        }
      })
    },
    currency(val) {
      if (val == '' || val == null) {
        return val
      }
      if (Number(val) == 0) {
        return 0
      }
      let precision = 0
      let decimal = this.checkNaN(val, (v) => v.toFixed(precision))
      const [n, d = []] = decimal.toString().split('.')
      return [n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')].concat(d).join('.')
      //   }
    },
    checkNaN(value, cb) {
      const val = parseFloat(value)
      return isNaN(val) ? undefined : cb(val)
    },
    toFixeds2(cellValue) {
      if (cellValue == 'Infinity%' || cellValue == null || cellValue == 0) {
        return '0%'
      } else {
        return (cellValue * 100).toFixed(0) + '%'
      }
    },
    toFixeds(cellValue) {
      if (cellValue == 'Infinity%' || cellValue == null || cellValue == 0) {
        return '0%'
      } else {
        return (cellValue * 100).toFixed(2) + '%'
      }
    },
    blurInputs1(row, items) {
      console.log(items)
      row.monthlyTargetAmount = Number(row.monthlyTargetQuantity * row.postExecutionAssessmentPrice)
      row.estimatedAmount1 = Number(row.estimatedQuantity1 * row.postExecutionAssessmentPrice)
      row.estimatedAmount2 = Number(row.estimatedQuantity2 * row.postExecutionAssessmentPrice)
      //   row.totalEstimatedCompletion1 = Number((row.estimatedAmount1 / row.monthlyTargetAmount) * 100)
      row.estimatedCompletion1 = Number(row.estimatedAmount1 / row.monthlyTargetAmount)
      row.estimatedGrowth1 = Number(row.estimatedAmount1 / row.lastYearAmount - 1)
      this.totalAll(items)
    },
    totalAll(row) {
      var estimatedQuantity2 = 0,
        estimatedQuantity1 = 0,
        monthlyTargetQuantity = 0,
        totalEstimatedCompletion1 = 0,
        totalEstimatedCompletion2 = 0,
        estimatedAmount2 = 0,
        estimatedAmount1 = 0,
        monthlyTargetAmount = 0
      for (var i in row) {
        if (row[i].groupM != 'TTL') {
          estimatedQuantity1 += row[i].estimatedQuantity1 ? Number(row[i].estimatedQuantity1) : 0
          estimatedQuantity2 += row[i].estimatedQuantity2 ? Number(row[i].estimatedQuantity2) : 0
          monthlyTargetQuantity += row[i].monthlyTargetQuantity ? Number(row[i].monthlyTargetQuantity) : 0
          //   totalEstimatedCompletion1 += row[i].totalEstimatedCompletion1 ? Number(row[i].totalEstimatedCompletion1) : 0
          //   totalEstimatedCompletion2 += row[i].totalEstimatedCompletion2 ? Number(row[i].totalEstimatedCompletion2) : 0
          estimatedAmount2 += row[i].estimatedAmount2 ? Number(row[i].estimatedAmount2) : 0
          estimatedAmount1 += row[i].estimatedAmount1 ? Number(row[i].estimatedAmount1) : 0
          monthlyTargetAmount += row[i].monthlyTargetAmount ? Number(row[i].monthlyTargetAmount) : 0
        } else {
          row[i].estimatedQuantity1 = estimatedQuantity1
          row[i].estimatedQuantity2 = estimatedQuantity2
          row[i].monthlyTargetQuantity = monthlyTargetQuantity
          row[i].totalEstimatedAmount2 = estimatedAmount2
          row[i].totalEstimatedAmount1 = estimatedAmount1
          row[i].totalMonthlyTargetAmount = totalMonthlyTargetAmount
          row[i].totalEstimatedCompletion1 = Number(row[i].estimatedAmount1 / row[i].totalMonthlyTargetAmount)
          row[i].totalEstimatedGrowth1 = Number(row[i].estimatedAmount1 / row[i].totalLastYearAmount - 1)
        }
      }
    },
    async save(res) {
      if (this.today_if == 0) {
        this.$alert('请于每月20日至23日期间填写本月预估片数和下月月初预估片数，以确保及时更新数据。', '提示', {
          confirmButtonText: '确定',
          dangerouslyUseHTMLString: true,
        })
        return
      }
      const { data } = await estimate_submitestimate(res)
      if (data.code == 200) {
        this.$message.success(data.msg)
      } else {
        this.$message.error(data.msg)
      }
    },
    async uploads() {
      let para = this.upload_from
      if (!para.endTime || !para.startTime) {
        this.$message.error('请选择开始时间和结束时间')
        return
      }
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        // spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const { data, headers } = await estimate_exportdata(para)
      uploadfiles(data, headers, this.loading)
    },
    async ExportAccount() {
      this.dialogVisible_upload = true
    },
    open_approve(res) {
      this.request_list = res
      this.dialogVisible_approve = true
      console.log(this.request_list)
    },
    async approve_submit(res) {
      if (res.CH_IF) {
        var { data } = await cataractnnvmp_approvalcancel(res)
      } else {
        var { data } = await cataractnnvmp_approvalclaim(res)
      }
      if (data.code == 200) {
        this.$message.success(data.msg)
      } else {
        this.$message.error(data.msg)
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 18 === 0) {
          return {
            rowspan: 18,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    // callFunction(item) {
    //   this.filters = {
    //     name: item.search,
    //   };
    //   this[item.Func].apply(this, item);
    // },
    handleCurrentChange(val) {
      this.pageNumber = val
      this.getModules()
    },
    getModules_search() {
      this.pageNumber = 1
      this.getModules()
    },
    // 合并数据
    mergeData(data) {
      //   let spanArr = []
      //   let concatSpanArr = []
      let merge = {}
      data.map((item, index) => {
        merge = {
          all_potential: item.potential,
          dip: item.dip,
          drg: item.drg,
        }
        item.details.map((item2, index2) => {
          item2 = { ...item2, ...merge }
          item.details[index2] = item2
        })
      })
      return data
      //   console.log(data)
    },
    //获取用户列表
    getModules() {
      let para = this.filters
      para.pageNumber = this.pageNumber
      console.log(para)
      // return
      //   let para = {
      //     pageNumber: this.pageNumber,
      //     key: this.filters.key
      //   };
      this.listLoading = true
      estimate_getlist(para).then((res) => {
        this.total = res.data.data.dataCount
        this.tabel_list = res.data.data.data
        this.listLoading = false
        this.SP_IF = this.$route.query.status
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    async estimate_getsubmissionsummary_fn() {
      const { data } = await estimate_monthlyreportsummary({})
      this.sionsummary_list = data.data
      if (this.sionsummary_list.approvalStatus == 2) {
        this.today_if = 0
      }
      console.log(this.sionsummary_list)
    },
  },
  mounted() {
    const now = new Date()
    const currentMonth = now.getMonth() + 1
    const nextMonth = now.getMonth() + 1 + 1
    console.log(nextMonth)
    this.now_Month = currentMonth
    if (nextMonth > 12) {
      this.next_Month = 1
    } else {
      this.next_Month = nextMonth
    }
    if (window.innerWidth <= 767) {
      this.isMobile = true
      this.collapsedClass = 'menu-collapsed'
      //   this.SidebarVisible = false
    }
    const date = new Date()
    const today = date.getDate()
    if (today > 19 && today < 24) {
      this.today_if = 2
    }
    this.estimate_getsubmissionsummary_fn()
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - 250
    })
    this.getModules()
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }

    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    console.log(this.buttonList)
  },
}
</script>

<style scoped></style>
<style>
.expends_cls2 .cell {
  padding: 0 5px !important;
}
.expends_cls2 td.el-table__cell {
  padding: 1px 0 !important;
}
.collapsessss > .el-collapse-item > div:nth-child(1) {
  height: 40px !important;
}
</style>
